import React, {lazy, Suspense} from "react";
import useWithStore from "@/Hooks/useWithStore";
import {useAllStore} from "@/Stores/useAllStore";
import {lazyWithPreload} from "@/Helpers/lazyWithPreload";

const NotificationModal = lazy(() => import('@/Components/Modal/NotificationModal'));
// const Cookie = lazy(() => import('@/pages/All/Cookie'));
// const SelectCityModal = lazy(() => import('@/pages/Header/SelectCityModal'));
// const ProfileDrawer = lazy(() => import('@/pages/Header/ProfileDrawer'));
// const SelectSizeModal = lazy(() => import('@/Components/Modal/SelectSizeModal'));
const NotSizeModal = lazy(() => import('@/Components/Modal/NotSizeModal'));
const SuccessAddWaitListModal = lazy(() => import('@/Components/Modal/SuccessAddWaitListModal'));
const FindOutYourSizeModal = lazy(() => import('@/Components/Modal/FindOutYourSizeModal'));
// const LoginOrRegistrationModal = lazy(() => import('@/Components/Modal/LoginOrRegistrationModal'));
const ServiceModal = lazy(() => import('@/pages/All/ServiceModal'));
// const Widget = lazy(() => import('@/pages/All/Widget'));
// const WidgetModal = lazy(() => import('@/Components/Modal/WidgetModal'));
const BuyOneClickModal = lazy(() => import('@/Components/Modal/BuyOneClickModal'));
// const QuickViewModal = lazy(() => import('@/Components/Modal/QuickViewModal'));
const DeliveryInformationModal = lazy(() => import('@/pages/All/DeliveryInformationModal'));
const ModalError = lazy(() => import('@/pages/All/ModalError'));
const FindOutPriceModal = lazy(() => import('@/Components/Modal/FindOutPriceModal'));
// const CreatingPreOrderModal = lazy(() => import('@/Components/Modal/CreatingPreOrderModal'));
const WheelOfFortuneModal = lazy(() => import('@/pages/All/WheelOfFortuneModal'));
const ApplicationDrawer = lazy(() => import('@/Components/Modal/ApplicationDrawer'));
// const DiscountFirstOrderModal = lazy(() => import('@/Components/Modal/DiscountFirstOrderModal'));
const SearchModal = lazy(() => import('@/Components/Modal/SearchModal'));
const ModalScanner = lazy(() => import('@/pages/Site/Search/ModalScanner'));
const SecretSantaDrawer = lazy(() => import('@/Components/Drawer/SecretSantaDrawer'));
const GiftCalendarModal = lazy(() => import('@/Components/Modal/GiftCalendarModal'));
// const CatalogMobileMenuDrawer = lazy(() => import('@/Components/Drawer/CatalogMobileMenuDrawer'));

const InfoDiscountModal = lazy(() => import("@/pages/Site/Product/InfoDiscountModal"));
const WriteReviewModal = lazy(() => import("@/Components/Modal/WriteReviewModal"));
const ZoomImageModal = lazy(() => import("@/pages/Site/Product/ZoomImageModal"));

const Cookie = lazyWithPreload(() =>
    import('@/widgets/cookie').then(module => ({
        default: module.Cookie,
    })),
);

const DiscountFirstOrderModal = lazyWithPreload(() =>
    import('@/features/discount-firs-order-modal').then(module => ({
        default: module.DiscountFirstOrderModal,
    })),
);

const ProfileNavigationDrawer = lazyWithPreload(() =>
    import('@/widgets/profile-navigation').then(module => ({
        default: module.ProfileNavigation,
    })),
);

const MobileMenuDrawer = lazyWithPreload(() =>
    import('@/widgets/mobile-menu-drawer').then(module => ({
        default: module.MobileMenuDrawer,
    })),
);

const SelectCityModal = lazyWithPreload(() =>
    import('@/widgets/select-city-modal').then(module => ({
        default: module.SelectCityModal,
    })),
);

const QuickViewModal = lazyWithPreload(() =>
    import('@/widgets/quick-view-modal').then(module => ({
        default: module.QuickViewModal,
    })),
);

const CatalogMenu = lazyWithPreload(() =>
    import('@/widgets/catalog-menu').then(module => ({
        default: module.CatalogMenu,
    })),
);

const AddProductInBasketModal = lazyWithPreload(() =>
    import('@/widgets/add-product-in-basket-modal').then(module => ({
        default: module.AddProductInBasketModal,
    })),
);

const LoginOrRegistrationModal = lazyWithPreload(() =>
    import('@/widgets/login-or-registration-modal').then(module => ({
        default: module.LoginOrRegistrationModal,
    })),
);

const ModalWindows = (props) => {
    const {config = {}, catalogMenu = [], profileNavigationData = [], user = {}, hideCookie = false} = props;
    const {daData = {}, staticCity = []} = config;

    const interactionFlag = useAllStore((state) => state.interactionFlag);

    if (!interactionFlag) return null;

    return (
        <>
            <Suspense><NotificationModal {...props} /></Suspense>
            <Suspense><Cookie hideCookie={hideCookie} /></Suspense>
            <Suspense><SelectCityModal staticCity={staticCity} daDataKey={daData.kav} /></Suspense>
            {/*<Suspense><Widget {...props} /></Suspense>*/}
            {/*<Suspense><WidgetModal {...props} /></Suspense>*/}
            {/*<Suspense><ProfileDrawer {...props} /></Suspense>*/}
            <Suspense><BuyOneClickModal {...props} /></Suspense>
            <Suspense><QuickViewModal {...props} /></Suspense>
            {/*<Suspense><SelectSizeModal {...props} /></Suspense>*/}
            <Suspense><NotSizeModal {...props} /></Suspense>
            <Suspense><SuccessAddWaitListModal {...props} /></Suspense>
            <Suspense><FindOutYourSizeModal {...props} /></Suspense>
            <Suspense><DeliveryInformationModal {...props} /></Suspense>
            <Suspense><ServiceModal {...props} /></Suspense>
            <Suspense><ModalError {...props} /></Suspense>
            <Suspense><FindOutPriceModal {...props} /></Suspense>
            {/*<Suspense><CreatingPreOrderModal {...props} /></Suspense>*/}
            <Suspense><WheelOfFortuneModal {...props} /></Suspense>
            <Suspense><ApplicationDrawer {...props} /></Suspense>
            <Suspense><SearchModal {...props} /></Suspense>
            <Suspense><ModalScanner {...props} /></Suspense>
            <Suspense><SecretSantaDrawer {...props} /></Suspense>
            <Suspense><GiftCalendarModal {...props} /></Suspense>
            <Suspense><MobileMenuDrawer {...props} /></Suspense>
            {/*Модальное окно "Скидка на первый заказ"*/}
            <Suspense><DiscountFirstOrderModal {...props} /></Suspense>
            {/*Модалка "Навигация ЛК"*/}
            <Suspense>
                <ProfileNavigationDrawer
                    navigation={profileNavigationData}
                    user={user}
                />
            </Suspense>
            {/*<Suspense><CatalogMobileMenuDrawer {...props} /></Suspense>*/}
            <Suspense><CatalogMenu catalogMenu={catalogMenu} /></Suspense>
            {/*Деталка*/}
            <Suspense><InfoDiscountModal {...props} /></Suspense>
            <Suspense><WriteReviewModal {...props} /></Suspense>
            <Suspense><ZoomImageModal {...props} /></Suspense>
            {/*Модалка "Добавить товар в корзину (если у изделия есть размеры)"*/}
            <Suspense><AddProductInBasketModal /></Suspense>
            {/*Модалка "Вход  или регистрация"*/}
            <Suspense><LoginOrRegistrationModal {...props} /></Suspense>
        </>
    );
};

export default useWithStore(ModalWindows);
